export enum ActionTypes {
 REMOVE_INTEGRATION = '[REMOVE_INTEGRATION] Remove integration',
 REMOVE_INTEGRATION_SUCCESS = '[REMOVE_INTEGRATION] Remove integration success',
 REMOVE_INTEGRATION_FAILURE = '[REMOVE_INTEGRATION] Remove integration failure',
}
